import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import arrow from '../../images/arrow-right-white.svg';

interface ImageCarouselProps {
	h2: string;
	images: Array<{
		imgSrc: string;
		topText: string;
		bottomText?: string;
		videoURL: string;
		name: string;
		position: string;
		buttonText: string;
		buttonLink: string;
	}>;
}
const ImageCarousel: React.FC<ImageCarouselProps> = (
	props: ImageCarouselProps
) => {
	SwiperCore.use([Autoplay, Pagination, Navigation]);
	return (
		<section className={'px-3 py-8 text-center'}>
			<div
				className={
					'container mx-auto flex flex-col items-center justify-center text-bt-gray'
				}
			>
				<h2 className={'pt-8 font-rubik text-4xl'}>{props.h2}</h2>
			</div>
			<div className={'testimonials-carousel container mx-auto'}>
				<Swiper
					modules={[Navigation, Pagination]}
					className={'mb-8 w-[800px] max-w-full max-sm:mt-8'}
					spaceBetween={50}
					loop
					navigation
					pagination={{ clickable: true }}
					autoplay={{ delay: 5000, disableOnInteraction: true }}
					slidesPerView={1}
				>
					{props.images.map((image) => {
						return (
							<SwiperSlide>
								<iframe
									className={
										'mx-auto my-12 aspect-video w-full max-w-[80%] max-md:my-4'
									}
									src={image.videoURL}
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									allowFullScreen
								/>
								<div className={'my-12 mb-16 '}>
									<h3 className={'mb-1 font-rubik text-3xl'}>
										Meet {image.name}
									</h3>
									<p className={'font-rubik text-xl'}>
										{image.position}
									</p>
									<p
										className={
											'pb-6 font-rubik text-xl max-md:pt-6'
										}
									>
										{image.bottomText}
									</p>
									<a href={image.buttonLink}>
										<button
											className={
												'mx-auto flex flex-row items-center rounded-full bg-bt-blue px-7 py-3 font-rubik text-xl font-medium text-white hover:bg-bt-red'
											}
										>
											{image.buttonText}
											<img
												className={'ml-3'}
												src={arrow}
												alt={'Arrow icon'}
											/>
										</button>
									</a>
								</div>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</section>
	);
};

export default ImageCarousel;
